import { render, staticRenderFns } from "./DepartmentView01.vue?vue&type=template&id=01bdb5e2&scoped=true&"
import script from "./DepartmentView01.vue?vue&type=script&lang=js&"
export * from "./DepartmentView01.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentView01.vue?vue&type=style&index=0&id=01bdb5e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bdb5e2",
  null
  
)

export default component.exports